import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Modal from '../../../common/modal/Modal';
import ChangeMaintenanceServiceOrderStatusForm from './ChangeMaintenanceServiceOrderStatusForm';
import { changeMaintenanceServiceOrderStatus } from '../../../../actions';

const ChangeMaintenanceServiceOrderStatusButton = ({
  maintenanceServiceOrderId,
  currentStatus,
  refreshServiceOrder,
  dispatchChangeMaintenanceServiceOrderStatus,
  onStatusChanged,
}) => {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  const onModalSubmit = async ({ status }) => {
    if (!status || !status.value) {
      return;
    }

    const updatedServiceOrder =
      await dispatchChangeMaintenanceServiceOrderStatus({
        maintenanceServiceOrderId,
        status: status.value,
        refreshServiceOrder,
      });

    if (!updatedServiceOrder) {
      return;
    }

    closeModal();

    if (onStatusChanged) {
      onStatusChanged(updatedServiceOrder);
    }
  };

  return (
    <>
      <Modal
        show={showModal}
        title="Cambiar estado de la orden"
        body={
          <ChangeMaintenanceServiceOrderStatusForm
            currentStatus={currentStatus}
            handleProcess={onModalSubmit}
            onCancel={closeModal}
          />
        }
        onClickClose={closeModal}
        size="md"
      />

      <Button color="secondary" onClick={openModal}>
        <i className="fa fa-exchange" /> Cambiar estado
      </Button>
    </>
  );
};

ChangeMaintenanceServiceOrderStatusButton.propTypes = {
  maintenanceServiceOrderId: PropTypes.number.isRequired,
  currentStatus: PropTypes.string,
  refreshServiceOrder: PropTypes.bool,
  dispatchChangeMaintenanceServiceOrderStatus: PropTypes.func.isRequired,
  onStatusChanged: PropTypes.func,
};

ChangeMaintenanceServiceOrderStatusButton.defaultProps = {
  currentStatus: null,
  refreshServiceOrder: false,
  onStatusChanged: null,
};

const mapDispatchToProps = {
  dispatchChangeMaintenanceServiceOrderStatus:
    changeMaintenanceServiceOrderStatus,
};

export default connect(
  null,
  mapDispatchToProps,
)(ChangeMaintenanceServiceOrderStatusButton);
